/** 企業中心 detail / edit / info / manage 等子頁（zh-TW） */
export default {
	shared: {
		merchantCat: {
			c1: "道觀",
			c2: "寺廟",
			c3: "教堂",
			c4: "冥想",
			c5: "身心靈療癒",
			c6: "靈性修行",
			c7: "心理諮詢",
		},
		businessStatus: {
			normal: "正常營業",
			paused: "暫停營業",
		},
		auditStatus: {
			auditing: "審核中",
			approved: "已通過",
			rejected: "已駁回",
			pendingSubmit: "待提交資料",
		},
		phoneMobile: "手機號",
		phoneLand: "座機號",
	},
	detail: {
		index: {
			missingMerchantId: "缺少機構ID",
			loadFailed: "加載數據失敗",
			loadFailedRetry: "加載數據失敗，請重試",
			loadErrorTitle: "數據加載失敗",
		},
		pc: {
			loading: "加載中...",
		},
		m: {
			follow: "追蹤",
			videoContent: "視頻內容",
			tabCover: "封面",
			tabVideo: "視頻",
			tabAlbum: "相冊",
			altCover: "封面",
			altAlbum: "相冊",
			managerTitle: "管理人",
			map: "地圖",
			phone: "電話",
			businessHoursTitle: "營業時間",
			orgIntroTitle: "機構介紹",
			introImageAlt: "機構介紹",
			featuredServicesTitle: "特色服務",
			bookNowAria: "立即預約",
		},
	},
	edit: {
		meta: {
			breadcrumb: "編輯機構",
		},
		breadcrumbMy: "我的機構",
		breadcrumbEdit: "編輯機構",
		tabBasic: "基礎信息",
		tabQualification: "機構資質",
		missingMerchantId: "缺少機構ID",
		updating: "正在更新...",
		updateSuccess: "更新成功",
		updateFailed: "更新失敗，請重試",
		saving: "正在保存...",
		saveSuccess: "保存成功，數據已保存到本地",
		saveFailed: "保存失敗，請重試",
		loadFailed: "加載數據失敗",
		loadFailedRetry: "加載數據失敗，請重試",
		mNavTitle: "機構入駐",
		mCancel: "取消",
		mSave: "保存",
	},
	info: {
		meta: {
			breadcrumb: "機構詳情",
		},
		breadcrumbMy: "我的機構",
		breadcrumbDetail: "機構詳情",
		tabBasic: "基礎信息",
		tabQualification: "機構資質",
		missingMerchantId: "缺少機構ID",
		loadFailed: "加載數據失敗",
		loadFailedRetry: "加載數據失敗，請重試",
		mNavTitle: "機構入駐",
		basic: {
			sectionBasic: "基礎信息",
			edit: "編輯",
			orgName: "機構名稱",
			orgNameEn: "機構英文名稱",
			category: "機構分類",
			businessStatus: "營業狀態",
			businessHours: "營業時間",
			thDay: "營業日",
			thTime: "營業時段",
			emptyHours: "暫無營業時間",
			contactPhone: "聯繫電話",
			thType: "類型",
			thNumber: "號碼",
			emptyPhone: "暫無聯繫電話",
			sectionAddress: "機構地址",
			country: "國家/地區",
			addressInfo: "地址信息",
			address: "詳細地址",
			addressEn: "英文詳細地址",
			coordinates: "經緯度",
			sectionMedia: "媒體資料",
			coverTitle: "機構頭像",
			imagesTitle: "商家圖片",
			videosTitle: "商家視頻",
			imgAltOrg: "機構圖片",
			emptyMedia: "暫無媒體資料",
			sectionDetail: "機構詳情",
			labelTraditional: "繁體",
			labelEnglish: "英文",
			sectionManager: "管理人",
			managerPhoto: "管理人照片",
			managerPhotoAlt: "管理人照片",
			noPhoto: "暫無照片",
			managerIntro: "管理人介紹",
			managerIntroEn: "英文介紹",
			sectionServices: "特色服務",
			serviceImgAlt: "服務圖片",
			noServiceImg: "暫無圖片",
			pricePrefix: "價格：",
			emptyServices: "暫無特色服務",
		},
		qualification: {
			title: "機構資質",
			orgName: "機構名稱",
			orgNameEn: "英文機構名稱",
			orgAddress: "機構地址",
			certificate: "社團登記證",
			certificateAlt: "社團登記證",
			noCertificate: "暫無登記證",
			managerName: "管理者姓名",
			managerContact: "管理者聯繫方式",
			modalTitle: "社團登記證",
		},
	},
	manage: {
		meta: {
			breadcrumb: "我的機構",
		},
		breadcrumbMy: "我的機構",
		tabInstitution: "機構管理",
		tabOrder: "訂單管理",
		orderSectionTitle: "訂單管理",
		institutionSectionTitle: "機構管理",
		query: "查詢",
		reset: "重置",
		joinEntry: "機構入駐",
		colOrgName: "機構名稱",
		colCategory: "機構分類",
		colAudit: "審核狀態",
		colBusiness: "營業狀態",
		colAddress: "地址",
		colActions: "操作",
		editNow: "立即編輯",
		manageAction: "管理",
		empty: "暫無數據",
		mNavInstitution: "我的機構",
		mNavOrder: "訂單管理",
		fetchFailed: "獲取數據失敗",
		orderPc: {
			filterOrderTime: "下單時間",
			startTime: "開始時間",
			endTime: "結束時間",
			filterStatus: "訂單狀態",
			all: "全部",
			filterNickname: "用戶暱稱",
			placeholderNickname: "請輸入用戶暱稱",
			colOrderNo: "訂單號",
			colOrderTime: "下單時間",
			colOrderStatus: "訂單狀態",
			colNickname: "用戶暱稱",
			colProduct: "商品資訊",
			colAmount: "商品金額",
			colReceipt: "實際收款",
			colPayTime: "支付時間",
			colRefund: "退款金額",
			none: "無",
			empty: "暫無數據",
			totalRecords: "總共 {n} 條記錄",
			refundModalTitle: "退款詳情",
			refundApplicant: "退款申請人：",
			refundApplyTime: "退款申請時間：",
			refundReason: "退款理由：",
			refundAmount: "退款金額：",
			refundStatus: "退款狀態：",
			refundTime: "退款時間：",
			orderStatusUnpaid: "未付款",
			orderStatusPaid: "已付款",
			orderStatusClosed: "已關閉",
			orderStatusRefunded: "已退款",
			orderStatusRefunding: "退款中",
			unknown: "未知",
			fetchOrderFailed: "獲取訂單數據失敗",
			refundSucceeded: "退款成功",
			refundFailed: "退款失敗",
			refundPending: "處理中",
			refundRejected: "已拒絕",
			refundDetailFailed: "獲取退款詳情失敗",
		},
		orderM: {
			filterOrderTime: "下單時間",
			startPlaceholder: "開始時間",
			to: "至",
			endPlaceholder: "結束時間",
			filterStatus: "訂單狀態",
			all: "全部",
			filterNickname: "用戶暱稱",
			placeholderNickname: "請輸入用戶暱稱",
			query: "查詢",
			reset: "重置",
			finishedText: "沒有更多了",
			empty: "暫無數據",
			statusAll: "全部",
			statusUnpaid: "未付款",
			statusPaid: "已付款",
			statusClosed: "已關閉",
			statusReviewed: "已評價",
			statusRefunded: "已退款",
			statusRefunding: "退款中",
			unknown: "未知",
			fetchFailed: "獲取訂單數據失敗",
			yearSuffix: "年",
			monthSuffix: "月",
			daySuffix: "日",
		},
		orderCard: {
			unknownUser: "未知用戶",
			unknownService: "未知服務",
			actualReceipt: "實際收款：",
			refundAmount: "退款金額：",
			orderNo: "訂單編號：",
			copy: "複製",
			orderTime: "下單時間：",
			payTime: "支付時間：",
			none: "無",
			orderNoEmpty: "訂單編號為空",
			copyUnsupported: "瀏覽器不支持複製功能",
			copySuccess: "複製成功",
			copyFailed: "複製失敗",
		},
		institutionCard: {
			auditLabel: "·審核狀態",
			businessLabel: "·營業狀態",
			manage: "管理",
			approvalTitle: "審批詳情",
			editNow: "立即編輯",
			cancel: "取消",
			approvalResult: "審批結果",
			approved: "通過",
			rejected: "駁回",
			approvalComment: "審批意見",
		},
	},
};
